export default __webpack_public_path__ + "b47472fbd3cab078a4c93e479cb0e300.png";